// extracted by mini-css-extract-plugin
module.exports = {"home":"Home_home__2JnLT","category-title":"Home_category-title__2cOah","category":"Home_category__-X5zP","image-container":"Home_image-container__3BsmW"};